import { render } from "./NavLink.vue?vue&type=template&id=2d58860a"
import script from "./NavLink.vue?vue&type=script&lang=js"
export * from "./NavLink.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__